var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_9097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 18,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 17,
    height: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_9097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 22.3758C10.6521 22.3758 10.3186 22.2371 10.0411 21.9596C9.76372 21.6822 9.625 21.3487 9.625 20.9591V11.0424C9.625 10.6529 9.76372 10.3194 10.0411 10.0419C10.3186 9.7645 10.6521 9.62578 11.0417 9.62578H15.6635C15.8997 9.62578 16.0767 9.69957 16.1948 9.84714C16.3128 9.9947 16.3719 10.157 16.3719 10.3341C16.3719 10.5112 16.3099 10.6735 16.1859 10.8211C16.062 10.9687 15.8819 11.0424 15.6458 11.0424H11.0417V20.9591H20.9583V16.3372C20.9583 16.1011 21.0321 15.924 21.1797 15.806C21.3273 15.6879 21.4896 15.6289 21.6667 15.6289C21.8438 15.6289 22.0061 15.6879 22.1536 15.806C22.3012 15.924 22.375 16.1011 22.375 16.3372V20.9591C22.375 21.3487 22.2363 21.6822 21.9589 21.9596C21.6814 22.2371 21.3479 22.3758 20.9583 22.3758H11.0417ZM13.875 17.4174V15.6997C13.875 15.5109 13.9104 15.3308 13.9813 15.1596C14.0521 14.9885 14.1524 14.8379 14.2823 14.7081L20.374 8.61641C20.5156 8.47474 20.675 8.36849 20.8521 8.29766C21.0292 8.22682 21.2063 8.19141 21.3833 8.19141C21.5722 8.19141 21.7523 8.22682 21.9234 8.29766C22.0946 8.36849 22.251 8.47474 22.3927 8.61641L23.3844 9.62578C23.5142 9.76745 23.6146 9.92387 23.6854 10.0951C23.7563 10.2662 23.7917 10.4404 23.7917 10.6174C23.7917 10.7945 23.7592 10.9687 23.6943 11.1398C23.6293 11.311 23.526 11.4674 23.3844 11.6091L17.2927 17.7008C17.1628 17.8306 17.0123 17.9339 16.8411 18.0107C16.67 18.0874 16.4899 18.1258 16.301 18.1258H14.5833C14.3826 18.1258 14.2144 18.0579 14.0786 17.9221C13.9429 17.7864 13.875 17.6181 13.875 17.4174ZM15.2917 16.7091H16.2833L20.3917 12.6008L19.8958 12.1049L19.3823 11.6091L15.2917 15.6997V16.7091Z",
    fill: "#092E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.36d608a56b45ecd55c8438ae8bc55072.svg";
export { ForwardRef as ReactComponent };